import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* The accordion rows sit on a 20px vertical rhythm, which falls between the theme's
   spacing.md (16px) and spacing.lg (24px). The Figma design specifies a raw 20px here
   too, so this stays a literal rather than being rounded onto the token scale. */
const ACCORDION_ROW_PADDING = '20px';

export const root = css`
  margin-bottom: var(${spacing.md});

  /* Family, weight and tracking come from the theme's global h1-h6 rule. Only the size
     steps up, matching the 390px and 502px drawer frames in the Figma design. */
  h2 {
    margin: 0 0 var(${spacing.md});
    font-size: var(${typography.heading.sizes.sm.fontSize});
    line-height: var(${typography.heading.sizes.sm.lineHeight});

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        font-size: var(${typography.heading.sizes.md.fontSize});
        line-height: var(${typography.heading.sizes.md.lineHeight});
      `,
    )}
  }

  /* The questions are headings structurally, but the design sets them in bold body text
     rather than the heading face, so the global h1-h6 rule is overridden here. */
  h3 {
    margin: 0;
    padding: ${ACCORDION_ROW_PADDING} 0;
    font-family: var(${typography.body.fontFamily});
    font-weight: 700;
    font-size: var(${typography.body.sizes.md.fontSize});
    line-height: var(${typography.body.sizes.md.lineHeight});
    letter-spacing: var(${typography.body.letterSpacing});
  }
`;

export const questions = css`
  margin: 0;
  border-radius: var(${borderRadius.md.desktop});
  border: 1px solid var(${colors.stroke.interactive});
  padding: 0 var(${spacing.md});
  list-style: none;

  li:not(:last-child) {
    border-bottom: 1px solid var(${colors.stroke.default});
  }
`;

export const answer = css`
  > p {
    font-size: var(${typography.body.sizes.md.fontSize});
    line-height: var(${typography.body.sizes.md.lineHeight});
  }
`;
